export default __webpack_public_path__ + "static/media/usability.ad6a6ec0.svg";